/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { browserHistory } from 'edrolo/utils/browserHistory';
import cx from 'classnames';
import scrollToComponent from 'react-scroll-to-component';
import { WistiaPreloader } from 'edrolo/domains/video';
import Chunk from '../Chunk';
import QuizIndicator from '../QuizIndicator';
import SupplementaryContent from '../SupplementaryContent';
import WrappedLink from 'edrolo/components/common/WrappedLink';
import SelfRateModal from '../SelfRateModal';
import style from './ChunkCarousel.scss';
import { QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import { utils as u } from 'edrolo-ui';

const DifficultyIndicator = ({ level, max = 3 }) => {
  return (
    <span>
      {
        // Create an array of <max> length and replace it with spans
        /* eslint-disable prefer-spread */
        Array.apply(null, { length: max }).map((brain, index) => (
          <span
            key={index}
            className={cx('icon-brain', style.brain, {
              [style.activeBrain]: level >= index + 1,
            })}
          />
        ))
      }
    </span>
  );
};

const KnowledgeUnits = ({ knowledgeUnits }) => {
  if (knowledgeUnits.length === 0) {
    return null;
  }
  const items = knowledgeUnits.map((ku) => {
    const { id, full_serial, title, difficulty } = ku.toJS();
    return (
      <li key={id}>
        <span className={style.title}>{full_serial}</span>
        <span className={style.title}>{title}</span>
        {difficulty !== null && <DifficultyIndicator level={difficulty} />}
      </li>
    );
  });

  return <ul className={style.knowledgeUnits}>{items}</ul>;
};

class ChunkCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chunkHeight: 0,
      showQuizIndicator: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.index === this.props.activeChunkIndex) {
      return;
    }
    this.setState({
      showQuizIndicator: false,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.index !== this.props.activeChunkIndex ||
      nextState.showQuizIndicator !== this.state.showQuizIndicator ||
      nextState.chunkHeight !== this.state.chunkHeight ||
      nextProps.playbackRate !== this.props.playbackRate
    );
  }

  get nextChunk() {
    const { lesson, activeChunkIndex } = this.props;
    return (
      lesson
        .get('chunks')
        .skipUntil((chunk) => chunk.get('index') === activeChunkIndex)
        .rest()
        .first() || null
    );
  }

  get prevChunk() {
    const { lesson, activeChunkIndex } = this.props;
    return lesson
      .get('chunks')
      .takeUntil((chunk) => chunk.get('index') === activeChunkIndex)
      .last();
  }

  handleChunkComplete = () => {
    if (this.nextChunk) {
      const url = this.props.buildChunkUrl(this.nextChunk.get('index'));
      browserHistory.push(url);
      return;
    }
  };

  handleChunkSizeKnown = (height) => {
    if (height === this.state.chunkHeight) {
      return;
    }
    this.setState({
      chunkHeight: height,
    });
  };

  handleNextMouseEnter = () => {
    if (this.shouldShowQuizIndicator) {
      this.setState({
        showQuizIndicator: true,
      });
    }
  };

  handleVideoEnd = () => {
    if (this.shouldShowQuizIndicator) {
      this.setState({
        showQuizIndicator: true,
      });
    }
  };

  get shouldAttemptQuiz() {
    const { activeChunk, lessonQuizAttempts } = this.props;
    const question = activeChunk.get('question');

    if (!question) {
      return false;
    }

    const quizAttempts = lessonQuizAttempts.filter(
      (qa) => qa.get('question') === question.get('id')
    );

    return (
      question.get('answer_type') !== QUESTION_TYPES.NO_RESPONSE &&
      quizAttempts.size === 0 &&
      !this.props.hasAttemptedQuestion
    );
  }

  get shouldShowQuizIndicator() {
    return (
      !this.state.showQuizIndicator &&
      this.props.activeChunk.get('video') &&
      this.shouldAttemptQuiz
    );
  }

  supplementaryContentRef = null;

  scrollToSupplementaryContent = () => {
    if (!this.supplementaryContentRef) {
      return;
    }
    scrollToComponent(this.supplementaryContentRef, {
      duration: 1000,
      align: 'top',
    });
  };

  render() {
    const {
      lesson,
      recordChunkVisit,
      activeChunk,
      hasSuccessMeasure,
      successMeasureChunks,
      lessonQuizAttempts,
      saveQuizAttempt,
    } = this.props;

    return (
      <>
        <KnowledgeUnits
          knowledgeUnits={activeChunk.get('knowledge_units_read_only')}
        />
        <div className="carousel modal-container">
          <div className="slides">
            <div className={cx('slide', u.relative)}>
              <div className="chunk-wrapper">
                <Chunk
                  lesson={lesson}
                  chunk={activeChunk}
                  recordChunkVisit={recordChunkVisit}
                  height={this.state.chunkHeight}
                  playbackRate={this.props.playbackRate}
                  onChunkSizeKnown={this.handleChunkSizeKnown}
                  onChunkComplete={this.handleChunkComplete}
                  onVideoEnd={this.handleVideoEnd}
                  isLastChunk={!this.nextChunk}
                  nextChunkUrl={
                    this.nextChunk &&
                    this.props.buildChunkUrl(this.nextChunk.get('index'))
                  }
                  successMeasureChunks={successMeasureChunks}
                  lessonQuizAttempts={lessonQuizAttempts}
                  saveQuizAttempt={saveQuizAttempt}
                />
                {this.prevChunk && (
                  <WrappedLink
                    className="carousel-nav"
                    id="prev"
                    to={this.props.buildChunkUrl(this.prevChunk.get('index'))}
                  />
                )}
                {this.nextChunk && (
                  <WrappedLink
                    className="carousel-nav"
                    id="next"
                    to={this.props.buildChunkUrl(this.nextChunk.get('index'))}
                    disabled={this.shouldAttemptQuiz}
                    onMouseEnter={this.handleNextMouseEnter}
                  />
                )}
              </div>

              {!this.nextChunk && (
                <SelfRateModal
                  ref="selfRateModal"
                  container={this}
                  disabled={this.shouldAttemptQuiz}
                  lesson={lesson}
                  onSave={this.props.onLessonComplete}
                  hasQuestionSet={this.props.hasQuestionSet}
                  hasSuccessMeasure={hasSuccessMeasure}
                />
              )}

              {this.state.showQuizIndicator ? (
                <QuizIndicator onClick={this.scrollToSupplementaryContent} />
              ) : null}
            </div>

            <SupplementaryContent
              lesson={lesson}
              chunk={activeChunk}
              lessonQuizAttempts={lessonQuizAttempts}
              saveQuizAttempt={saveQuizAttempt}
              onChunkComplete={(...args) => this.handleChunkComplete(...args)}
              ref={(ref) => {
                this.supplementaryContentRef = ref;
              }}
            />
            {this.nextChunk && this.nextChunk.get('video') && (
              <WistiaPreloader video={this.nextChunk.get('video')} />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ChunkCarousel;
